(() => {
  const TARGET = '#tba-gpo-slot';
  const ACCORDION = '#tba-gpo-accordion';

  const GPO_SELECTORS = [
    '.gpo-container',
    '.gpo-app',
    '.gpo-form',
    '.gpo-group.gpo-form__group.gpo-col-12'
  ];

  function findGPO() {
    for (const sel of GPO_SELECTORS) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function move() {
    const target = document.querySelector(TARGET);
    const accordion = document.querySelector(ACCORDION);
    const gpo = findGPO();
    if (!target || !accordion || !gpo) return false;

    if (!target.contains(gpo)) {
      target.appendChild(gpo);
      accordion.classList.add('is-active');
    }
    return true;
  }

  if (move()) return;

  const obs = new MutationObserver(() => {
    if (move()) obs.disconnect();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 8000);
})();